<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-chip color="primary" v-on="on" label>
        <v-icon left>
          mdi-account-circle-outline
        </v-icon>
        {{ user && user.name }}
      </v-chip>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(item, index) in userItem"
        :key="index"
        link
        @click="operate(item.text)"
        class="pr-3 pl-2"
      >
        <v-list-item-icon class="mr-3">
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data: () => ({
    userItem: [
      {
        icon: 'mdi-border-color',
        text: '修改密码'
      },
      {
        icon: 'mdi-logout',
        text: '退出登陆'
      }
    ]
  }),
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['logout']),
    operate(item) {
      if (item === '修改密码') {
        this.$store.commit('setChangePasswordShow', true);
      } else {
        this.logout();
      }
    }
  }
};
</script>
